export default __webpack_public_path__ + "static/media/break_regular_fill.ebda5690.ttf";